import * as React         from 'react';
import { useTranslation } from 'react-i18next';
import DV                 from 'ts-data-validator';

import { RenderRadio } from './RenderRadio';

import AccordionArrowIcon from '../../icons/AccordionArrowIcon';

const RenderRadioGroup = function(props) {
  const {t} = useTranslation();

  const {
          alwaysEnabled,
          facets,
          options,
          queryKey,
          setFilterHandler,
          selectedValues
        } = props;

  const [showAll, setShowAll] = React.useState(false);

  const selectedOptionId = React.useMemo(() => {
    const value = selectedValues?.[queryKey];

    return !DV.isNull(value) && !DV.isUndefined(value) ? value : null;
  }, [selectedValues, queryKey]);

  // facets: offers left if the option is picked; a picked option stays enabled to be unpicked.
  // The options that lead nowhere go to the end (the order inside both groups is kept).
  const sortedOptions = React.useMemo(() => {
    if (!facets || alwaysEnabled) {
      return options;
    }

    const isDisabled = (option) => (facets[String(option?.ID)] ?? 0) === 0 && !(
      !DV.isNull(selectedOptionId) && Number(selectedOptionId) === Number(option?.ID)
    );

    return [...options.filter((option) => !isDisabled(option)), ...options.filter(isDisabled)];
  }, [options, facets, selectedOptionId, alwaysEnabled]);

  const visibleOptions = React.useMemo(() => {
    return showAll ? sortedOptions : sortedOptions.slice(0, 3);
  }, [showAll, sortedOptions]);

  return (
    <div className={'radio_group'}>
      <RenderRadio
        checked={!selectedOptionId}
        label={t('label_all')}
        onClick={() => {
          setFilterHandler(null);
        }}
      />
      {visibleOptions.map((option) => {
        const isChecked =
                !DV.isNull(selectedOptionId) &&
                Number(selectedOptionId) === Number(option?.ID);

        const count = facets ? (facets[String(option?.ID)] ?? 0) : undefined;

        return (
          <RenderRadio
            key={option?.ID}
            checked={isChecked}
            count={count}
            disabled={!alwaysEnabled && count === 0 && !isChecked}
            label={option?.label}
            onClick={() => {
              setFilterHandler(option.ID);
            }}
          />
        );
      })}
      {options.length > 3 && (
        <div
          className={'show_more_wrapper'}
          onClick={() => {
            setShowAll(!showAll);
          }}
        >
          <p>{showAll ? t('hide') : t('more')}</p>
          <AccordionArrowIcon
            isOpen={!showAll}
            fill={'#488ec8'}
          />
        </div>
      )}
    </div>
  );
};

export default RenderRadioGroup;